module.exports = __webpack_public_path__ + "img/logo.f529f0c7.webp";